import { Grid, Link, Typography, Box } from '@mui/material';
import { sxStyles } from './styles';

const FooterMainLogo = ({ pageConfiguration, theme }) => {
  const sxStyle = sxStyles(theme);
  return (
    <Grid item xs={12} lg={2} sx={sxStyle.footerSectionsContainer1}>
      <Grid container direction="column" sx={sxStyle.logosContainer}>
        <Box sx={sxStyle.logoAndContact}>
          <Link href="/" align="left" sx={sxStyle.primaryLogoLink}>
            <Box
              component="img"
              src={pageConfiguration.site_logos.footer}
              alt={pageConfiguration.site_logos.alt}
              sx={sxStyle.primaryLogo}
            />
          </Link>
          {pageConfiguration.id !== 1 && (
            <Box sx={sxStyle.secondaryContainer}>
              <Typography sx={sxStyle.contactInfo}>
                {pageConfiguration.address}
              </Typography>

              <Typography sx={sxStyle.contactInfo}>
                {pageConfiguration.country}
              </Typography>

              <Typography sx={sxStyle.contactInfo}>
                {pageConfiguration.telephone}
              </Typography>

              <Typography sx={sxStyle.contactInfo}>
                {pageConfiguration.email}
              </Typography>
            </Box>
          )}
          {pageConfiguration.site_functions.showFifteen && (
            <Link
              sx={sxStyle.secondaryContainer}
              href="http://quince.viajestdh.com.ar"
              target="_blank"
            >
              <Box
                component="img"
                src={pageConfiguration.site_logos.fifteenFooterLogo}
                alt={pageConfiguration.site_logos.alt}
                sx={sxStyle.primaryLogo}
              />
            </Link>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default FooterMainLogo;
